import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=d9550708&"
import script from "./Rates.vue?vue&type=script&lang=js&"
export * from "./Rates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports